module.exports = __webpack_public_path__ + "static/media/importPerson.e07b00fa.xlsx";